import { render, staticRenderFns } from "./BudgetActions.vue?vue&type=template&id=4126bf20&scoped=true&"
import script from "./BudgetActions.vue?vue&type=script&lang=ts&"
export * from "./BudgetActions.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetActions.vue?vue&type=style&index=0&id=4126bf20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4126bf20",
  null
  
)

export default component.exports